// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__yCxYm","pillCheckbox":"styles_pillCheckbox__Np7CC"};